import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/common";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Switch } from "../components/ui/switch";
import { toast } from "sonner";
import { Download, Save } from "lucide-react";

const DAYS = [["1","Lun"],["2","Mar"],["3","Mer"],["4","Gio"],["5","Ven"],["6","Sab"],["0","Dom"]];

export default function Impostazioni() {
  const [cfg, setCfg] = useState(null);

  const load = async () => { const { data } = await api.get("/whatsapp/config"); setCfg(data); };
  useEffect(() => { load(); }, []);

  const save = async () => {
    await api.put("/whatsapp/config", cfg);
    toast.success("Impostazioni salvate"); load();
  };
  if (!cfg) return <p className="text-muted-foreground animate-pulse">Caricamento…</p>;

  const toggleDay = (d) => {
    const n = Number(d); const cur = cfg.team_send_days || [];
    setCfg({ ...cfg, team_send_days: cur.includes(n) ? cur.filter(x=>x!==n) : [...cur, n] });
  };

  return (
    <div className="max-w-3xl">
      <PageHeader title="Impostazioni" subtitle="Configurazione messaggi, esportazioni e trasferimento" />

      <div className="card-soft p-5 mb-5">
        <h3 className="font-head font-bold mb-4">WhatsApp — Squadre</h3>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Orario invio mattutino</Label><Input type="time" data-testid="cfg-team-time" value={cfg.team_send_time||""} onChange={(e)=>setCfg({...cfg,team_send_time:e.target.value})} /></div>
          <div><Label>Numero aziendale</Label><Input value={cfg.company_phone||""} onChange={(e)=>setCfg({...cfg,company_phone:e.target.value})} /></div>
        </div>
        <div className="mt-4"><Label>Giorni di invio</Label>
          <div className="flex gap-1.5 mt-1 flex-wrap">
            {DAYS.map(([d,l])=>{const sel=(cfg.team_send_days||[]).includes(Number(d));return(
              <button key={d} onClick={()=>toggleDay(d)} className={`text-xs px-3 py-1.5 rounded-full border ${sel?"bg-brand text-white border-brand":"bg-white text-muted-foreground"}`}>{l}</button>);})}
          </div>
        </div>
        <label className="flex items-center gap-2 mt-4 text-sm"><Switch checked={cfg.team_send_on_empty} onCheckedChange={(v)=>setCfg({...cfg,team_send_on_empty:v})} /> Invia anche nei giorni senza montaggi</label>
      </div>

      <div className="card-soft p-5 mb-5">
        <h3 className="font-head font-bold mb-4">WhatsApp — Clienti</h3>
        <label className="flex items-center gap-2 text-sm mb-4"><Switch checked={cfg.client_reminder_enabled} onCheckedChange={(v)=>setCfg({...cfg,client_reminder_enabled:v})} data-testid="cfg-client-enabled" /> Promemoria clienti attivi</label>
        <div className="mb-4"><Label>Anticipo promemoria (ore prima)</Label><Input type="number" data-testid="cfg-client-hours" value={cfg.client_reminder_hours||24} onChange={(e)=>setCfg({...cfg,client_reminder_hours:Number(e.target.value)})} className="max-w-[160px]" /></div>
        <div><Label>Modello messaggio cliente</Label>
          <Textarea rows={4} data-testid="cfg-client-template" value={cfg.client_template||""} onChange={(e)=>setCfg({...cfg,client_template:e.target.value})} />
          <p className="text-xs text-muted-foreground mt-1">Segnaposto: {"{nome}"} {"{intervento}"} {"{data}"} {"{ora}"} {"{indirizzo}"} {"{numero_aziendale}"}</p>
        </div>
      </div>

      <Button className="bg-brand text-white mb-6" data-testid="cfg-save" onClick={save}><Save size={16} className="mr-1" /> Salva impostazioni</Button>

      <div className="card-soft p-5">
        <h3 className="font-head font-bold mb-3">Esportazione dati</h3>
        <div className="flex flex-wrap gap-2">
          {[["clients","Clienti"],["quotes","Preventivi"],["payments","Incassi"]].map(([k,l])=>(
            <a key={k} href={`${api.defaults.baseURL}/export/${k}.csv`} target="_blank" rel="noreferrer"><Button variant="outline" size="sm"><Download size={14} className="mr-1" /> {l} CSV</Button></a>
          ))}
          <a href={`${api.defaults.baseURL}/reports/stats.pdf`} target="_blank" rel="noreferrer"><Button variant="outline" size="sm"><Download size={14} className="mr-1" /> Report PDF</Button></a>
        </div>
        <p className="text-xs text-muted-foreground mt-3">Backup, trasferimento su altro hosting e dettaglio costi: vedi documentazione tecnica fornita separatamente (README).</p>
      </div>
    </div>
  );
}
